import config from '../../config';
import axios from 'axios';

// Create `axios` instance passing the newly created `cache.adapter`
const cachedHttp = axios.create({
  headers: {
    Accept: 'application/json'
  }
});

export default {
  uploadFile: file => {
    return new Promise((resolve, reject) => {
      var formData = new FormData()
      formData.append('file', file)
      axios
        .post(config.apiEndpoints.helperUri.concat('uploadFile'), formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(
          response => {
            resolve(response)
          },
          error => {
            reject(error)
          }
        );
    });
  },
  getNumbers: function(s) {
    const r = s.match(/\d+/g)
    if (r && r.length > 0) {
      return r[0]
    }
    return null
  },
  getAddressFromZipCode: function(zipCode) {
    const n = this.getNumbers(zipCode);
    return new Promise((resolve, reject) => {
      if (n == null) {
        reject({ message: 'zipCode is invalid' })
      }
      const auth = axios.defaults.headers.common['Authorization']
      delete axios.defaults.headers.common['Authorization']
      cachedHttp.get(config.apiEndpoints.viaCepUri.concat(`${n}/json`)).then(
        response => {
          axios.defaults.headers.common['Authorization'] = auth
          resolve(response.data)
        },
        error => {
          axios.defaults.headers.common['Authorization'] = auth
          reject(error)
        }
      )
    })
  },
  cnaeGetList: () => {
    return new Promise((resolve, reject) => {
      const auth = axios.defaults.headers.common['Authorization']
      delete axios.defaults.headers.common['Authorization']
      cachedHttp.get(config.apiEndpoints.cnaeListUri).then((response)=>{
        axios.defaults.headers.common['Authorization'] = auth;
        resolve(response)
      }, (error)=>{
        axios.defaults.headers.common['Authorization'] = auth
        reject(error)
      })
    })
  },
  mccGetList: () => {
    return new Promise((resolve, reject) => {
      const auth = axios.defaults.headers.common['Authorization']
      delete axios.defaults.headers.common['Authorization']
      cachedHttp.get(config.apiEndpoints.mccListUri).then((response)=>{
        axios.defaults.headers.common['Authorization'] = auth;
        resolve(response)
      }, (error)=>{
        axios.defaults.headers.common['Authorization'] = auth
        reject(error)
      })
    })
  },
  banksGetList: () => {
    return new Promise((resolve, reject) => {
      const auth = axios.defaults.headers.common['Authorization']
      delete axios.defaults.headers.common['Authorization']
      cachedHttp.get(config.apiEndpoints.bankListUri).then((response)=>{
        axios.defaults.headers.common['Authorization'] = auth;
        if(config.partnersConfiguration.banks.useDefault) {
          let bank = response.data.find(function (el) { return parseInt(el.COMPE, 0) == config.partnersConfiguration.banks.defaultBankCode })
          response.data = [];
          response.data.push(bank);
        }
        resolve(response)
      }, (error)=>{
        axios.defaults.headers.common['Authorization'] = auth
        reject(error)
      })
    })
  }
};
